import {
  createReasonBlock,
  createReasonDetailBlock,
  getReasons,
  getReasonsDetail,
  requestFileDocumentSupport,
  updateReasonBlock,
  updateReasonDetailBlock,
  updateStatusReasonBlock,
  updateStatusReasonDetailBlock
} from '../../utils/api';
import { fetchThenDownload } from '../../utils/hooks';
import { actionTypes } from './constants';

export function setFailedAction({ key, message, error }) {
  return { type: actionTypes.FAILED, key, message, error };
}

export function setLoadingAction({ key, loading = true }) {
  return { type: actionTypes.LOADING, key, loading };
}

export function setSuccessAction({
  key,
  data,
  meta = {},
  initial = true,
  message = '',
  success = true
}) {
  return { type: actionTypes.SUCCESS, key, data, meta, initial, message, success };
}

export function fetchReasons(type, nextpage, search, initial = true) {
  return async (dispatch, getState) => {
    const key = type || 'dataReason';
    const state = getState();
    const { page, totalPage } = state.settingReasonBlockId[type]?.meta || { page: 0, totalPage: 0 };
    if (!initial && page > 1 && page >= totalPage) {
      return;
    } else {
      try {
        const params = {
          search,
          size: 100,
          page: nextpage,
        };
        dispatch(setLoadingAction({ key }));
        const response = key === 'dataReason'
          ? await getReasons(params)
          : await getReasonsDetail(params);
        const data = initial ?
          response.data : [...state.settingReasonBlockId[type]?.data || {}, ...response.data];
        dispatch(setSuccessAction({ key, data, meta: response.meta, initial }));
      } catch (error) {
        const { message } = error;
        dispatch(setFailedAction({ key, message }));
      }
    }
  };
}

export function fetchCreateReason(type = 'createReason', payload = {}, setToastr) {
  return async (dispatch) => {
    const key = type || 'createReason';
    try {
      dispatch(setLoadingAction({ key }));
      const formData = new FormData();

      Object.entries(payload).forEach(([key, value]) => {
        formData.append(key, value);
      });
      const { data } = type === 'createReason' ?
        await createReasonBlock(formData) : await createReasonDetailBlock(payload);
      dispatch(setSuccessAction({ key, data }));
      setToastr({
        desc: `Berhasil menambahkan ${type === 'createReason' ? 'alasan' : 'keterangan'} blokir NIK.`,
        type: 'success',
        visible: true,
      });
      if (key.includes('Detail')) {
        dispatch(fetchReasons('dataReasonDetail'));
      } else {
        dispatch(fetchReasons('dataReason'));
      }
    } catch (error) {
      const { message } = error;
      dispatch(setFailedAction({ key, message }));
      setToastr({
        desc: `Gagal menambahkan ${type === 'createReason' ? 'alasan' : 'keterangan'} blokir NIK.`,
        type: 'danger',
        visible: true,
      });
    }
  };
}

export function fetchUpdateReason(type, payload, setToastr) {
  return async (dispatch) => {
    const key = type || 'updateReason';
    try {
      dispatch(setLoadingAction({ key }));
      const { data } = type === 'updateReason' ? await updateReasonBlock(payload) : await updateReasonDetailBlock(payload);
      dispatch(setSuccessAction({ key, data }));
      setToastr({
        desc: `Berhasil memperbarui ${type === 'updateReason' ? 'alasan' : 'keterangan'} blokir NIK.`,
        type: 'success',
        visible: true,
      });
      if (key.includes('Detail')) {
        dispatch(fetchReasons('dataReasonDetail'));
      } else {
        dispatch(fetchReasons('dataReason'));
      }
    } catch (error) {
      const { message } = error;
      dispatch(setFailedAction({ key, message }));
      setToastr({
        desc: `Gagal memperbarui ${type === 'updateReason' ? 'alasan' : 'keterangan'} blokir NIK.`,
        type: 'danger',
        visible: true,
      });
    }
  };
}

export function fetchUpdateStatusReason(type, payload, setToastr) {
  return async (dispatch) => {
    const key = type || 'updateStatusReason';
    try {
      dispatch(setLoadingAction({ key }));
      const { data } = type === 'updateStatusReason' ? await updateStatusReasonBlock(payload) : await updateStatusReasonDetailBlock(payload);
      dispatch(setSuccessAction({ key, data }));
      setToastr({
        desc: `Berhasil mengubah status ${type === 'createReason' ? 'alasan' : 'keterangan'} blokir NIK.`,
        type: 'success',
        visible: true,
      });
      if (key.includes('Detail')) {
        dispatch(fetchReasons('dataReasonDetail'));
      } else {
        dispatch(fetchReasons('dataReason'));
      }
    } catch (error) {
      const { message } = error;
      dispatch(setFailedAction({ key, message }));
      setToastr({
        desc: `Gagal mengubah status ${type === 'updateReason' ? 'alasan' : 'keterangan'} blokir NIK.`,
        type: 'danger',
        visible: true,
      });
    }
  };
}

export function fetchDocumentSupportReason(params,callback = () => {}) {
  return async (dispatch) => {
    const key = 'requestSummaryFile';
    try {
      dispatch(setLoadingAction({ key, isLoading: true }));
      const { data, code, message, status } =
      await requestFileDocumentSupport(params);
      dispatch(setSuccessAction({ key, data, code, message, status }));
      await fetchThenDownload(data?.url, 'document_support_reason.pdf');
      callback({ success: true });
    } catch (error) {
      dispatch(setFailedAction({
        key,
        data: error.data, message: error?.message,
        code: error?.code || null, error
      }));
      dispatch(setLoadingAction({ key, isLoading: false }));
      callback({ success: false });
    }
  };
}
